export enum EmailVerificationStatus {
  Invalid = 'invalid',
  Expired = 'expired',
}
